/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from 'ethers'
import { Provider } from '@ethersproject/providers'
import type { RenGatewayRegistryV2, RenGatewayRegistryV2Interface } from '../RenGatewayRegistryV2'

const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'string',
                name: 'asset',
                type: 'string',
            },
            {
                indexed: false,
                internalType: 'address',
                name: 'signatureVerifier',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'address',
                name: 'token',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'string',
                name: 'version',
                type: 'string',
            },
        ],
        name: 'LockGatewayProxyDeployed',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'string',
                name: 'symbol',
                type: 'string',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'token',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'gatewayContract',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'string',
                name: 'indexedSymbol',
                type: 'string',
            },
        ],
        name: 'LogLockGatewayAdded',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'string',
                name: 'symbol',
                type: 'string',
            },
            {
                indexed: true,
                internalType: 'string',
                name: 'indexedSymbol',
                type: 'string',
            },
        ],
        name: 'LogLockGatewayRemoved',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'string',
                name: 'symbol',
                type: 'string',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'token',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'gatewayContract',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'string',
                name: 'indexedSymbol',
                type: 'string',
            },
        ],
        name: 'LogMintGatewayAdded',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'string',
                name: 'symbol',
                type: 'string',
            },
            {
                indexed: true,
                internalType: 'string',
                name: 'indexedSymbol',
                type: 'string',
            },
        ],
        name: 'LogMintGatewayRemoved',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'oldSignatureVerifier',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'newSignatureVerifier',
                type: 'address',
            },
        ],
        name: 'LogSignatureVerifierUpdated',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'oldTransferContract',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'newTransferContract',
                type: 'address',
            },
        ],
        name: 'LogTransferContractUpdated',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'string',
                name: 'asset',
                type: 'string',
            },
            {
                indexed: false,
                internalType: 'address',
                name: 'signatureVerifier',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'address',
                name: 'token',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'string',
                name: 'version',
                type: 'string',
            },
        ],
        name: 'MintGatewayProxyDeployed',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'uint256',
                name: 'chainId',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'string',
                name: 'asset',
                type: 'string',
            },
            {
                indexed: false,
                internalType: 'string',
                name: 'name',
                type: 'string',
            },
            {
                indexed: false,
                internalType: 'string',
                name: 'symbol',
                type: 'string',
            },
            {
                indexed: false,
                internalType: 'uint8',
                name: 'decimals',
                type: 'uint8',
            },
            {
                indexed: false,
                internalType: 'string',
                name: 'version',
                type: 'string',
            },
        ],
        name: 'RenAssetProxyDeployed',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'bytes32',
                name: 'role',
                type: 'bytes32',
            },
            {
                indexed: true,
                internalType: 'bytes32',
                name: 'previousAdminRole',
                type: 'bytes32',
            },
            {
                indexed: true,
                internalType: 'bytes32',
                name: 'newAdminRole',
                type: 'bytes32',
            },
        ],
        name: 'RoleAdminChanged',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'bytes32',
                name: 'role',
                type: 'bytes32',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'account',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'sender',
                type: 'address',
            },
        ],
        name: 'RoleGranted',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'bytes32',
                name: 'role',
                type: 'bytes32',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'account',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'sender',
                type: 'address',
            },
        ],
        name: 'RoleRevoked',
        type: 'event',
    },
    {
        inputs: [],
        name: 'CAN_ADD_GATEWAYS',
        outputs: [
            {
                internalType: 'bytes32',
                name: '',
                type: 'bytes32',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'CAN_UPDATE_GATEWAYS',
        outputs: [
            {
                internalType: 'bytes32',
                name: '',
                type: 'bytes32',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'DEFAULT_ADMIN_ROLE',
        outputs: [
            {
                internalType: 'bytes32',
                name: '',
                type: 'bytes32',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'NAME',
        outputs: [
            {
                internalType: 'string',
                name: '',
                type: 'string',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: 'chainId_',
                type: 'uint256',
            },
            {
                internalType: 'address',
                name: 'signatureVerifier_',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'transferContract',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'renAssetProxyBeacon_',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'mintGatewayProxyBeacon_',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'lockGatewayProxyBeacon_',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'adminAddress',
                type: 'address',
            },
            {
                internalType: 'address[]',
                name: 'gatewayDeployers',
                type: 'address[]',
            },
        ],
        name: '__GatewayRegistry_init',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'renAssetProxyBeacon_',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'mintGatewayProxyBeacon_',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'lockGatewayProxyBeacon_',
                type: 'address',
            },
        ],
        name: '__RenAssetFactory_init',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'string',
                name: 'symbol',
                type: 'string',
            },
            {
                internalType: 'address',
                name: 'lockAsset',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'lockGateway',
                type: 'address',
            },
        ],
        name: 'addLockGateway',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'string',
                name: 'symbol',
                type: 'string',
            },
            {
                internalType: 'address',
                name: 'renAsset',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'mintGateway',
                type: 'address',
            },
        ],
        name: 'addMintGateway',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'string',
                name: 'symbol',
                type: 'string',
            },
            {
                internalType: 'address',
                name: 'lockToken',
                type: 'address',
            },
            {
                internalType: 'string',
                name: 'version',
                type: 'string',
            },
        ],
        name: 'deployLockGateway',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'string',
                name: 'symbol',
                type: 'string',
            },
            {
                internalType: 'address',
                name: 'renAsset',
                type: 'address',
            },
            {
                internalType: 'string',
                name: 'version',
                type: 'string',
            },
        ],
        name: 'deployMintGateway',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'string',
                name: 'symbol',
                type: 'string',
            },
            {
                internalType: 'string',
                name: 'erc20Name',
                type: 'string',
            },
            {
                internalType: 'string',
                name: 'erc20Symbol',
                type: 'string',
            },
            {
                internalType: 'uint8',
                name: 'erc20Decimals',
                type: 'uint8',
            },
            {
                internalType: 'string',
                name: 'version',
                type: 'string',
            },
        ],
        name: 'deployMintGatewayAndRenAsset',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'getChainId',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'string',
                name: 'tokenSymbol',
                type: 'string',
            },
        ],
        name: 'getGatewayBySymbol',
        outputs: [
            {
                internalType: 'contract IMintGateway',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'token',
                type: 'address',
            },
        ],
        name: 'getGatewayByToken',
        outputs: [
            {
                internalType: 'contract IMintGateway',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'string',
                name: 'tokenSymbol',
                type: 'string',
            },
        ],
        name: 'getLockAssetBySymbol',
        outputs: [
            {
                internalType: 'contract IERC20',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'string',
                name: 'tokenSymbol',
                type: 'string',
            },
        ],
        name: 'getLockGatewayBySymbol',
        outputs: [
            {
                internalType: 'contract ILockGateway',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'token_',
                type: 'address',
            },
        ],
        name: 'getLockGatewayByToken',
        outputs: [
            {
                internalType: 'contract ILockGateway',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'getLockGatewayProxyBeacon',
        outputs: [
            {
                internalType: 'contract LockGatewayProxyBeacon',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: 'from',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'count',
                type: 'uint256',
            },
        ],
        name: 'getLockGatewaySymbols',
        outputs: [
            {
                internalType: 'string[]',
                name: '',
                type: 'string[]',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'string',
                name: 'tokenSymbol',
                type: 'string',
            },
        ],
        name: 'getMintGatewayBySymbol',
        outputs: [
            {
                internalType: 'contract IMintGateway',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'token',
                type: 'address',
            },
        ],
        name: 'getMintGatewayByToken',
        outputs: [
            {
                internalType: 'contract IMintGateway',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'getMintGatewayProxyBeacon',
        outputs: [
            {
                internalType: 'contract MintGatewayProxyBeacon',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: 'from',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'count',
                type: 'uint256',
            },
        ],
        name: 'getMintGatewaySymbols',
        outputs: [
            {
                internalType: 'string[]',
                name: '',
                type: 'string[]',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'string',
                name: 'tokenSymbol',
                type: 'string',
            },
        ],
        name: 'getRenAssetBySymbol',
        outputs: [
            {
                internalType: 'contract IERC20',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'getRenAssetProxyBeacon',
        outputs: [
            {
                internalType: 'contract RenAssetProxyBeacon',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: 'role',
                type: 'bytes32',
            },
        ],
        name: 'getRoleAdmin',
        outputs: [
            {
                internalType: 'bytes32',
                name: '',
                type: 'bytes32',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: 'role',
                type: 'bytes32',
            },
            {
                internalType: 'uint256',
                name: 'index',
                type: 'uint256',
            },
        ],
        name: 'getRoleMember',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: 'role',
                type: 'bytes32',
            },
        ],
        name: 'getRoleMemberCount',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'getSignatureVerifier',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'string',
                name: 'tokenSymbol',
                type: 'string',
            },
        ],
        name: 'getTokenBySymbol',
        outputs: [
            {
                internalType: 'contract IERC20',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'getTransferContract',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: 'role',
                type: 'bytes32',
            },
            {
                internalType: 'address',
                name: 'account',
                type: 'address',
            },
        ],
        name: 'grantRole',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: 'role',
                type: 'bytes32',
            },
            {
                internalType: 'address',
                name: 'account',
                type: 'address',
            },
        ],
        name: 'hasRole',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'string',
                name: 'symbol',
                type: 'string',
            },
        ],
        name: 'removeLockGateway',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'string',
                name: 'symbol',
                type: 'string',
            },
        ],
        name: 'removeMintGateway',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: 'role',
                type: 'bytes32',
            },
            {
                internalType: 'address',
                name: 'account',
                type: 'address',
            },
        ],
        name: 'renounceRole',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: 'role',
                type: 'bytes32',
            },
            {
                internalType: 'address',
                name: 'account',
                type: 'address',
            },
        ],
        name: 'revokeRole',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes4',
                name: 'interfaceId',
                type: 'bytes4',
            },
        ],
        name: 'supportsInterface',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'newSignatureVerifier',
                type: 'address',
            },
        ],
        name: 'updateSignatureVerifier',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'newTransferContract',
                type: 'address',
            },
        ],
        name: 'updateTransferContract',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
]

export class RenGatewayRegistryV2__factory {
    static readonly abi = _abi
    static createInterface(): RenGatewayRegistryV2Interface {
        return new utils.Interface(_abi) as RenGatewayRegistryV2Interface
    }
    static connect(address: string, signerOrProvider: Signer | Provider): RenGatewayRegistryV2 {
        return new Contract(address, _abi, signerOrProvider) as RenGatewayRegistryV2
    }
}
